var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Notes")]),_c('v-card-text',[_c('v-alert',{attrs:{"type":"info","border":"top","elevation":"2","colored-border":""}},[_vm._v(" "+_vm._s(_vm.notes)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }